// extracted by mini-css-extract-plugin
module.exports = {"plans":"single-plans-module--plans--1_Ln5","center":"single-plans-module--center--FO7Pl","post":"single-plans-module--post--3Ujxu"};